import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8 14.67c3.667 0 6.667-3 6.667-6.667s-3-6.667-6.666-6.667-6.667 3-6.667 6.667 3 6.666 6.667 6.666"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M5.166 8.004 7.053 9.89l3.78-3.774"
    }, null, -1)
  ])]);
}
const CheckTickCircleIcon = { render };
export {
  CheckTickCircleIcon as default,
  render
};
//# sourceMappingURL=check-tick-circle.svg.js.map
